import { RpcObservableRequestContext } from '../rpc-observable-request';
import { RpcObservableResultContext } from '../rpc-observable-result';

/**
 * RPC Extension Data request name and version.
 */
export class RpcObservableExtensionDataKey {
    public static command = 'ExtensionDataObservable';
    public static version = '0.1.0';
}

/**
 * Rpc observable extension data.
 */
export interface RpcObservableExtensionDataRequest extends RpcObservableRequestContext {
    extension: string;
    key: string;
    data?: string;
}

export interface RpcObservableExtensionDataResult extends RpcObservableResultContext {
    data?: string;
}

export interface RpcObservableExtensionDataError extends RpcObservableResultContext {
    error: string;
}
